<template>
  <div @click="onReplyEvent(item, true)">
    <div class="item-container">
      <div class="avatar-container">
        <img class="item-avatar" :src="item.avatar" />
        <img
          class="icon_header_v"
          src="../../static/ic_v_log.png"
          v-if="item.isAuthor"
        />
      </div>
      <div class="right-continer">
        <div class="s8 t1 title-container">
          {{ item.nickname }}
          <span class="item-owner c5 s2 b-c6" v-if="showOwner">楼主</span>
        </div>
        <div class="s8 item-comment" :class="commentColor">
          {{ item.content }}
          <span v-if="item.parentComent">
            //
            <span class="c5">{{ '@' + item.parentComent.nickname + ':' }}</span>
            <span :class="parentCommentColor">{{
              item.parentComent.content
            }}</span>
          </span>
        </div>
        <div class="timer-container">
          <div class="s4 t3">
            {{ item.createTime }}
          </div>
          <div class="item-replay s4 t1">{{ replyTitle }}</div>
        </div>

        <div
          class="delete-container"
          v-if="canDelete"
          @click.stop="onDeleteEvent(item)"
        >
          <div class="btn-delete s2 t1">删除</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import status from '@/api/appInfo'
import dayjs from 'dayjs'
import userInfoUtils from '@/util/UserInfoUtils'

export default {
  name: 'comment-item',

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },

    showReplyCount: {
      type: Boolean,
      default: false
    },

    showDelete: {
      type: Boolean,
      default: true
    },

    showOwner: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    replyTitle() {
      if (this.showReplyCount) {
        return this.item.replyCount + ' 回复'
      } else {
        return '回复'
      }
    },

    commentColor() {
      if (this.item.isAuthor) {
        return 'c9'
      } else {
        return 't1'
      }
    },

    parentCommentColor() {
      if (this.item.parentComent.isAuthor) {
        return 'c9'
      } else {
        return 't1'
      }
    },

    canDelete() {
      return userInfoUtils.getUserId() == this.item.userId && this.showDelete
    }
  },

  methods: {
    dayjs,
    onReplyEvent(item, isShowAll) {
      this.$emit('onShowAllEvent', isShowAll)
      this.$emit('onReplyEvent', item)
    },

    onDeleteEvent(item) {
      this.$dialog
        .confirm({
          title: '提示',
          message: '确定删除这条评论吗？',
          confirmButtonColor: '#046bcc',
          cancelButtonColor: '#999',
          overlayClass: 'my-dialog'
        })
        .then(() => {
          this.$emit('onDeleteEvent', item)
        })
        .catch(() => {
          console.log('你点击了confirm的取消')
        })
    }
  },

  mounted() {}
}
</script>

<style scoped>
.item-container {
  position: relative;
  display: flex;
  flex-direction: row;
}

.avatar-container {
  height: 71px;
  width: 71px;
  position: relative;
  margin-top: 40px;
  margin-left: 30px;
}

.item-avatar {
  height: 71px;
  width: 71px;
  border-radius: 35px;
}

.icon_header_v {
  width: 26px;
  height: 26px;
  position: absolute;
  bottom: 0px;
  right: 0px;
}

.right-continer {
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  margin-top: 42px;
  position: relative;
  width: 100%;
}

.title-container {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.item-comment {
  margin-top: 24px;
}

.item-owner {
  padding: 5px;
  background-color: #e8f0fa;
  border-radius: 5px;
  margin-left: 5px;
  height: 20px;
  line-height: 20px;
}

.timer-container {
  margin-top: 18px;
  display: flex;
  flex-direction: row;
}

.item-replay {
  height: 34px;
  line-height: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 17px;
  margin-left: 20px;
  background-color: #e9e9e9;
  padding: 0px 10px;
}

.delete-container {
  position: absolute;
  top: 0;
  right: 10px;
  width: 100px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.btn-delete {
  border: 1px solid #262626;
  border-radius: 15px;
  text-align: center;
  width: 60px;
  height: 30px;
  line-height: normal;
}
</style>
<style>
.my-dialog {
  background: rgba(0,0,0,.5);
}
</style>
